import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { environment } from "src/environments/environment";
import { ContactLeadRequest } from "../models/contact-request.interface";

@Injectable({
    providedIn: "root",
})
export class ContactService{
    private readonly apiUrl = `${environment.apiURL}/api/${environment.version}/ContactLead`;
    constructor(
        private http: HttpClient,
    ){}

    submitContact(data: ContactLeadRequest){
        return this.http.post(this.apiUrl, data);
    }
}